import { useState, useEffect, useRef } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function TextWithEllipsis({ value }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const textRef = useRef(null);

  const handleShowFullName = (event) => {
    event.stopPropagation();
    setIsHidden(!isHidden);
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    setTimeout(() => {
      if (textRef?.current?.scrollWidth > textRef?.current?.clientWidth) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
    }, 100);
  }, []);

  return (
    <SoftBox display="flex" alignItems="center" height="100%" width="100%">
      <SoftBox
        sx={{
          width: isHidden ? "100%" : "max-content",
          maxWidth: value.maxWidth,
          whiteSpace: isHidden ? "nowrap" : "normal",
          overflow: isHidden ? "hidden" : "auto",
          textOverflow: isHidden ? "ellipsis" : "clip",
          wordBreak: "break-word",
        }}
        ref={textRef}
      >
        {value.name}
      </SoftBox>
      {(isHidden || isExpanded) && value?.name ? (
        <SoftTypography
          variant="caption"
          color="secondary"
          sx={{ cursor: "pointer" }}
          onClick={handleShowFullName}
          alignSelf={isHidden ? "center" : "end"}
        >
          &nbsp;{" "}
          <span style={{ textDecoration: "underline" }}>
            {isHidden ? "Show more" : "Show less"}
          </span>
        </SoftTypography>
      ) : null}
    </SoftBox>
  );
}

export default TextWithEllipsis;
